module.exports = __webpack_public_path__ + "img/1轻度与无拥挤.cc39f63b.gif";